import { render } from "./UserPasswordForgot.vue?vue&type=template&id=a9ab7064"
import script from "./UserPasswordForgot.vue?vue&type=script&lang=js"
export * from "./UserPasswordForgot.vue?vue&type=script&lang=js"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__